function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import PropTypes from 'prop-types';
import groupBy from 'lodash/groupBy';
import keys from 'lodash/keys';
import reduce from 'lodash/reduce';
import format from 'date-fns/format';
import { Wrapper, Timeline } from './styles';
export var TimelineView = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TimelineView, _React$PureComponent);

  var _super = _createSuper(TimelineView);

  function TimelineView(props) {
    var _this;

    _classCallCheck(this, TimelineView);

    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this, props].concat(rest));

    _defineProperty(_assertThisInitialized(_this), "getItemDateInWords", function (item) {
      var getDate = _this.props.getDate;
      return format(getDate(item), 'E, MMM d');
    });

    _defineProperty(_assertThisInitialized(_this), "trimGroups", function (groups) {
      var itemsInView = _this.state.itemsInView;

      var _ref = itemsInView >= 0 ? reduce(groups, function (_ref2, groupCur, groupKey) {
        var trimmedGroups = _ref2.trimmedGroups,
            itemsRemain = _ref2.itemsRemain;

        if (itemsRemain > 0) {
          trimmedGroups[groupKey] = groupCur;
          itemsRemain -= groupCur.length;
        }

        return {
          trimmedGroups: trimmedGroups,
          itemsRemain: itemsRemain
        };
      }, {
        trimmedGroups: {},
        itemsRemain: itemsInView
      }) : {
        trimmedGroups: groups
      },
          trimmedGroups = _ref.trimmedGroups;

      return {
        groupedItems: trimmedGroups,
        renderMore: keys(groups).length > keys(trimmedGroups).length
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onMoreClick", function () {
      var itemsPerPage = _this.props.itemsPerPage;

      _this.setState(function (prevState) {
        return {
          itemsInView: prevState.itemsInView + itemsPerPage
        };
      });
    });

    _this.state = {
      itemsInView: props.itemsPerPage
    };
    return _this;
  }

  _createClass(TimelineView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          items = _this$props.items,
          renderTimeline = _this$props.children,
          verticalLineOffset = _this$props.verticalLineOffset,
          rest = _objectWithoutProperties(_this$props, ["items", "children", "verticalLineOffset"]);

      var _this$trimGroups = this.trimGroups(groupBy(items, this.getItemDateInWords)),
          groupedItems = _this$trimGroups.groupedItems,
          renderMore = _this$trimGroups.renderMore;

      return /*#__PURE__*/React.createElement(Wrapper, rest, /*#__PURE__*/React.createElement(Timeline, {
        verticalLineOffset: verticalLineOffset
      }, renderTimeline(groupedItems, renderMore && this.onMoreClick)));
    }
  }]);

  return TimelineView;
}(React.PureComponent);
TimelineView.defaultProps = {
  items: [],
  itemsPerPage: -1,
  getDate: function getDate(item) {
    return item.date;
  }
};
export var propTypeTimelineViewItem = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  date: PropTypes.instanceOf(Date),
  time: PropTypes.instanceOf(Date),
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.element.isRequired,
  items: PropTypes.arrayOf(PropTypes.string),
  markerProps: PropTypes.object
});
TimelineView.propTypes = {
  items: PropTypes.arrayOf(propTypeTimelineViewItem).isRequired,
  itemsPerPage: PropTypes.number,
  children: PropTypes.func.isRequired,
  verticalLineOffset: PropTypes.number,
  getDate: PropTypes.func
};
export default TimelineView;